module.exports = __webpack_public_path__ + "media/packs/images/flags/KM-26a5925870bce8ac9fd0ed302dbc07ae.png";